declare const utag: any;
export type TrackEventParams = {
  category?: string;
  subcategory?: string;
  specificProps?: Record<string, string>;
};

export const trackEvent = (
  event_name: string,
  { category = "", subcategory = "", specificProps }: TrackEventParams = {}
) => {
  const utagObj = {
    event_name: event_name,
    page_path: location.pathname,
    tomtom_domain: location.origin,
    page_category: category,
    page_subcategory: subcategory,
    ...specificProps,
  };

  if ("utag" in window) {
    utag.link(utagObj);
  }
};
